export interface User {
  name: string;
  mask: boolean;
  permanentMask: boolean;
  canEdit: boolean;
  browser: string;
  computer: string;
  hasCases: boolean;
  hash: string;
  ip: string;
  mode: string;
  rights: Array<string>;
  isAdmin: boolean;
  areas: Array<string>;
  unit: string;
  room: string;
  route: string;
  sessionStart: string;
  status: number;
  userID: string;
  email: string;
  pagerID: string;
  isTesting: boolean;
  isActiveTesting: boolean;
}

export interface ProfileState {
  accessRequestResult: any;
  system: Record<string, any>;
  systemLoaded: boolean;
  data: User;
  error: boolean;
  area: string;
  speechSynthesisEnabled: boolean;
  alertRepeatInterval: number;
  audioAlertsEnabled: boolean;
  preferences: Record<string, any>;

  hasShownLoginMs: boolean;

  activeTestList: ActiveCaseTest[];
}

export interface ActiveCaseTest {
  logID: string;
  startDate: Date;
  area: string;
  roomID: string;
  patientID: string;
}

export const enum PreferenceKeys {
  TEMPERATURE = "temperature"
}

export interface Preference {
  key: PreferenceKeys;
  value: any;
}

export type TemperatureTypes = "C" | "F";
